// @flow
import * as React from 'react';
import { TextInput as GrommetInput, Stack } from 'grommet';
import {
    injectIntl, defineMessages,
} from 'react-intl';
import FieldWrapper from '../grommet2/forms/fields/FieldWrapper';
import StyledCloseButton from '../grommet2/forms/fields/StyledCloseButton';

type Props = {
    onChange: (e: SyntheticInputEvent<number>) => void,
    onFocus?: (e: SyntheticFocusEvent<HTMLInputElement>) => void,
    onBlur?: (e: SyntheticFocusEvent<any>) => void,
    // eslint-disable-next-line react/no-unused-prop-types
    value?: any;
    name: string;
    disabled?: boolean,
}

const TextInput = (props: Props): React.Node => {
    const {
        disabled,
        name,
        onChange,
        onFocus,
        onBlur,
        value,
    } = props;

    // const [value, setValue] = React.useState('');

    /* Fixes problem with not refreshing buttons when using clear on the input, if this input is part of a form
    make sure to have an individual handleChange in the form that will receive only the value of the input. */
    const handleChange = (e) => {
        // setValue(e.target.value);
        onChange(e);
    };

    const handleBlur = ((e) => {
        e.target.value.trim();
    });

    const onClear = (() => {
        // setValue('');
        onChange(name, 'clear');
    });

    return (
        <FieldWrapper
            name={name}
        >
            <Stack anchor="right">
                <GrommetInput
                    name={name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={value || ''}
                    id={`id-${name}`}
                    disabled={disabled}
                />
                {value && !disabled && <StyledCloseButton onClick={onClear} plain />}
            </Stack>
        </FieldWrapper>
    );
};

const messages = defineMessages({
    min: {
        id: 'textinput-min',
        defaultMessage: 'The length of this field must be more than {minLimit} characters!',
    },
    max: {
        id: 'textinput-max',
        defaultMessage: 'The length of this field must be less than {maxLimit} characters!',
    },
    required: {
        id: 'textinput-required',
        defaultMessage: 'This field is required.',
    },
    inputType: {
        id: 'textinput-wrong-type',
        defaultMessage: 'Wrong input type.',
    },
});

// TextInput.getValidationSchema = (field: { validation: Object }, ui) => {
//     let errMsg = Yup.string().nullable();
//     if (field.validation.required) {
//         errMsg = Yup.string().required(messages.required).nullable();
//     }
//     if (field.validation.min_length) {
//         errMsg = errMsg.min(field.validation.min_length.toString(),
//             { ...messages.min, values: { minLimit: field.validation.min_length.toString() } });
//     }
//     if (field.validation.max_length) {
//         errMsg = errMsg.max(field.validation.max_length.toString(),
//             { ...messages.max, values: { maxLimit: field.validation.max_length.toString() } });
//     }
//     if (ui?.regex_validation) {
//         errMsg = Yup.string().matches(new RegExp(ui.regex_validation), messages.inputType).nullable();
//     }
//
//     return errMsg;
// };

TextInput.defaultProps = {
    onChange: () => null,
    onFocus: () => null,
    onBlur: () => null,
    value: '',
    name: '',
    disabled: false,
};

export default injectIntl(TextInput);
